// extracted by mini-css-extract-plugin
export var dropdownButton = "_1c-0";
export var fullWidthDropdownButton = "_1c-1";
export var icon = "_1c-3";
export var iconPlaceholder = "_1c-2";
export var menuItemRow = "_1c-9";
export var separator = "_1c-e";
export var shortcutContainer = "_1c-7";
export var shortcutContainerFilled = "_1c-8";
export var shortcutIconLg = "_1c-6";
export var shortcutIconMd = "_1c-5";
export var shortcutIconSm = "_1c-4";
export var submenuChevron = "_1c-d";
export var submenuDropdown = "_1c-a";
export var submenuTriggerRow = "_1c-b";
export var submenuTriggerRowOpen = "_1c-c";